function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { consumeContext as consumeEditorContext } from "../EditorContext";
import { consumeContext as consumeOverlayContext } from "../OverlayContext";
import { Gallery, Info, Text, Preview, Frames, Undo, Redo } from "../../Misc/Icons";
import { ASSETS_TOOLBAR, TEXT_TOOLBAR, FRAMES_TOOLBAR } from "../Types";
import Assets from "./Assets";
import TextToolbar from "./Text";
import FramesToolbar from "./Frames";

var Toolbar = function (_React$Component) {
  _inherits(Toolbar, _React$Component);

  function Toolbar() {
    _classCallCheck(this, Toolbar);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Toolbar.prototype.getToolbarSections = function getToolbarSections() {
    return [this.props.EditorContext.assets.hasAssets() && {
      type: ASSETS_TOOLBAR,
      icon: React.createElement(Gallery, null),
      title: "Gallery",
      toolbar: React.createElement(Assets, null)
    }, {
      type: TEXT_TOOLBAR,
      icon: React.createElement(Text, null),
      title: "Text",
      toolbar: React.createElement(TextToolbar, null)
    }, this.props.EditorContext.frames.hasFrames() && {
      type: FRAMES_TOOLBAR,
      icon: React.createElement(Frames, null),
      title: "Frames",
      toolbar: React.createElement(FramesToolbar, null)
    }].filter(function (val) {
      return !!val;
    });
  };

  Toolbar.prototype.getToolbarHint = function getToolbarHint() {
    var selectedToolbar = this.props.EditorContext.state.selectedToolbar;

    switch (selectedToolbar) {
      case ASSETS_TOOLBAR:
        return "Drag and drop elements anywhere in the video to make it personal.";

      case TEXT_TOOLBAR:
        return "Click on the video to add text.";

      case FRAMES_TOOLBAR:
        return "Select a custom frame";

      default:
        return "";
    }
  };

  Toolbar.prototype.render = function render() {
    var _props = this.props,
        EditorContext = _props.EditorContext,
        OverlayContext = _props.OverlayContext;
    var _EditorContext$state = EditorContext.state,
        selectedToolbar = _EditorContext$state.selectedToolbar,
        isPreviewEnabled = _EditorContext$state.isPreviewEnabled;
    var _OverlayContext$state = OverlayContext.state,
        history = _OverlayContext$state.history,
        historyCursor = _OverlayContext$state.historyCursor;
    var undoDisabled = historyCursor === 0;
    var redoDisabled = historyCursor === history.length - 1;
    var toolbarSections = this.getToolbarSections();
    return React.createElement("section", null, toolbarSections.reduce(function (result, toolbarConfig) {
      return selectedToolbar === toolbarConfig.type ? toolbarConfig.toolbar : result;
    }, null), React.createElement("div", {
      className: "recorder__toolbar"
    }, toolbarSections.map(function (_ref) {
      var type = _ref.type,
          icon = _ref.icon,
          title = _ref.title;
      return React.createElement("button", {
        key: type,
        className: "recorder__toolbar-button " + (type === selectedToolbar ? "is-active" : ""),
        onClick: function onClick() {
          return EditorContext.selectToolbar(type);
        }
      }, icon, React.createElement("span", null, title));
    }), React.createElement("div", {
      className: "recorder__toolbar-info"
    }, this.getToolbarHint()), React.createElement("button", {
      className: "recorder__toolbar-button recorder__toolbar-button--last " + (undoDisabled ? "" : "is-active"),
      onClick: OverlayContext.undo,
      disabled: undoDisabled
    }, React.createElement(Undo, null), React.createElement("span", null, "Undo")), React.createElement("button", {
      className: "recorder__toolbar-button " + (redoDisabled ? "" : "is-active"),
      onClick: OverlayContext.redo,
      disabled: redoDisabled
    }, React.createElement(Redo, null), React.createElement("span", null, "Redo")), React.createElement("button", {
      className: "recorder__toolbar-button " + (isPreviewEnabled ? "is-active" : ""),
      onClick: function onClick() {
        return EditorContext.togglePreview();
      }
    }, React.createElement(Preview, null), React.createElement("span", null, "preview")), React.createElement("button", {
      className: "recorder__toolbar-button",
      onClick: function onClick() {
        return EditorContext.setHelpModalVisibility(true);
      }
    }, React.createElement(Info, null), React.createElement("span", null, "help"))));
  };

  return Toolbar;
}(React.Component);

Toolbar.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired,
  OverlayContext: PropTypes.object.isRequired
} : {};
export default consumeOverlayContext(consumeEditorContext(Toolbar));